"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolygonFilter = void 0;
const Polygon_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Polygon.js"));
const BufferOp_js_1 = __importDefault(require("jsts/org/locationtech/jts/operation/buffer/BufferOp.js"));
const PointLocator_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocator.js"));
const Location_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Location.js"));
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const boundingBox_1 = require("../boundingBox");
class PolygonFilter {
    //通过多边形内缩的方式排除掉墙
    eliminate(polygons) {
        for (let i = polygons.length - 1; i >= 0; i--) {
            let polygon = polygons[i];
            if (polygon.getArea() < 2000000) { //只是个经验值
                polygons.splice(i, 1);
            }
        }
        for (let i = polygons.length - 1; i >= 0; i--) {
            let polygon = polygons[i];
            let bufferResult = BufferOp_js_1.default.bufferOp(polygon, -150); //一般的墙宽度为200，两边各内缩150是为了增加容错
            //应该只会有Polygon和MultiPolygon两种类型
            if (bufferResult instanceof Polygon_js_1.default) {
                if (bufferResult.getExteriorRing().getCoordinates().length == 0) {
                    polygons.splice(i, 1);
                }
                else {
                    if (bufferResult.getArea() < 800000) { //只是个经验值
                        polygons.splice(i, 1);
                    }
                }
            }
            else {
                let bufferPolygons = new Array();
                for (let j = 0; j < bufferResult.getNumGeometries(); j++) {
                    bufferPolygons.push(bufferResult.getGeometryN(j));
                }
                for (let j = bufferPolygons.length - 1; j >= 0; j--) {
                    let bufferPolygon = bufferPolygons[j];
                    if (bufferPolygon.getExteriorRing().getCoordinates().length == 0) {
                        bufferPolygons.splice(j, 1);
                    }
                    else {
                        if (bufferPolygon.getArea() < 800000) { //只是个经验值
                            bufferPolygons.splice(j, 1);
                        }
                    }
                }
                if (bufferPolygons.length == 0) {
                    polygons.splice(i, 1);
                }
            }
        }
    }
    //排除掉被其他多边形的孔洞完全包含的多边形
    removePolygonWhichWholeInOtherHole(polygons) {
        let holes = new Array();
        let holeBoundingBoxes = new Array();
        for (let polygon of polygons) {
            for (let i = 0; i < polygon.getNumInteriorRing(); i++) {
                const hole = polygon.getInteriorRingN(i);
                holes.push(hole);
                holeBoundingBoxes.push(new boundingBox_1.BoundingBox(hole.getCoordinates()));
            }
        }
        for (let i = polygons.length - 1; i >= 0; i--) {
            let polygon = polygons[i];
            let shellPoints = polygon.getExteriorRing().getCoordinates();
            let boundingBox = new boundingBox_1.BoundingBox(shellPoints);
            //先通过包围盒判断
            for (let j = 0; j < holeBoundingBoxes.length; j++) {
                let holeBoundingBox = holeBoundingBoxes[j];
                if (holeBoundingBox.contains(boundingBox.min) && holeBoundingBox.contains(boundingBox.max)) {
                    let holeRing = holes[j];
                    if (this.isLinearRingCompletelyContainsAnother(holeRing, shellPoints)) {
                        //再加个条件，面积差距过大（2倍以上）的就当成正常房间，不过滤
                        if (new GeometryFactory_js_1.default().createPolygon(holeRing).getArea() > polygon.getArea() * 2) {
                            continue;
                        }
                        polygons.splice(i, 1);
                        break;
                    }
                }
            }
        }
    }
    //通过判断点是否全在多边形内来判断是否被完全包含
    isLinearRingCompletelyContainsAnother(holeRing, anotherPoints) {
        let pointLocator = new PointLocator_js_1.default();
        for (let point of anotherPoints) {
            if (pointLocator.locateInPolygonRing(point, holeRing) == Location_js_1.default.EXTERIOR) {
                return false;
            }
        }
        return true;
    }
}
exports.PolygonFilter = PolygonFilter;
